import type { Group } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { omit } from "@mixitone/util";
import { ColorDot } from "./ColorDot";

type Props = Omit<React.ComponentProps<typeof ColorDot>, "color" | "children" | "shape"> & {
  group: Group;
  label?: React.ReactNode;
};

export const GroupDot = ApplicationView((props: Props) => {
  const group = props.group;
  const rest = omit(props, ["group", "label"]);

  return (
    <ColorDot color={group?.asColor?.hex() || "black"} shape={group?.shape || "circle"} {...rest}>
      {props.label ?? group?.initial}
    </ColorDot>
  );
});
